module.exports = __webpack_public_path__ + "img/txt.325197ed.svg";